export default {"src":"/_next/static/media/question.e449bd04.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};